export class PasswordResetConfirm {
    uid: string;
    token: string;
    new_password: string;
    re_new_password: string;
}
